import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=3218e330&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3218e330",
  null
  
)

export default component.exports